// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2rtqV","productName":"Table_productName__23HGx"};